import { useState } from "react";
import { Button } from "@mui/material";
import { JobOrder } from "../../interfaces/job.interface";
import useAdminAssignmentEnabled from "../../hooks/useAdminAssignmentEnabled";
import { assignableJob, pendingTrips } from "../../services/JobAssignmentService";
import JobAssignmentDialog from "./JobAssignmentDialog";

export default function JobAssignmentButton({ job, onAssigned }: {job: JobOrder; onAssigned: () => Promise<void>}) {
  const enabled = useAdminAssignmentEnabled(); const [open, setOpen] = useState(false);
  if (!enabled || !assignableJob(job) || !pendingTrips(job).length) return null;
  return <><Button variant="outlined" onClick={() => setOpen(true)}>Assign / reassign driver</Button>
    {open && <JobAssignmentDialog open onClose={() => setOpen(false)} jobId={Number(job.jobId)} onAssigned={onAssigned}/>}</>;
}
